import React, { useContext } from "react";
import { Grid, Typography, Button, Box } from "@mui/material";
import { useIntl } from "react-intl";
import PropTypes from "prop-types";
import panelBtnItems from "./panelBtnItems";
import { StoreContext } from "../../../../../../../../../../../../store/StoreProvider";

const ResultsPanel = ({ btnShow, title }) => {
  const [state, dispatch] = useContext(StoreContext);
  const { sna } = state;
  const { tableData } = sna.AI;
  const intl = useIntl();

  return (
    <Grid
      sx={{
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        marginBottom: "16px",
      }}
    >
      <Typography
        sx={{
          fontSize: "1rem",
          fontWeight: "700",
          display: "flex",
          alignItems: "center",
        }}
      >
        {intl.formatMessage({
          id: "sna.sidetool.digitalAITool.ai.AIanalyze.result.title",
          defaultMessage: title,
        })}
      </Typography>
      {btnShow && (
        <Box>
          {panelBtnItems.map((el) => (
            <Button
              key={el.id}
              sx={{
                padding: "8px 24px",
                borderRadius: "6px",
                border: "1px solid #E7E7E7",
                fontSize: "14px",
                fontWeight: "400",
                lineHeight: "20.27px",
                color: "#121212",
                marginLeft: "8px",
              }}
              startIcon={el.icon && <img src={el.icon} alt="" />}
              onClick={() => el.func(dispatch, tableData)}
            >
              {el.name}
            </Button>
          ))}
        </Box>
      )}
    </Grid>
  );
};

export default ResultsPanel;

ResultsPanel.propTypes = {
  btnShow: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
};
